import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, MessageSquareQuote } from 'lucide-react';
interface Props {
  onNext: () => void;
}
const teams = ['Medical', 'Commercial', 'Market Access', 'Congress Team'];
export const Screen4Reveal = ({
  onNext
}: Props) => {
  const [selected, setSelected] = useState<string | null>(null);
  const [revealed, setRevealed] = useState(false);
  const handleSelect = (team: string) => {
    if (revealed) return;
    setSelected(team);
    setTimeout(() => {
      setRevealed(true);
    }, 800);
  };
  return <div className="relative w-full h-full bg-slate-950 overflow-hidden flex flex-col" data-id="element-375">
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900 via-slate-950 to-slate-950" data-id="element-376" />

      <div className="relative z-10 flex-1 flex flex-col p-8 pt-16" data-id="element-377">
        <motion.span initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="text-[10px] tracking-[0.3em] uppercase text-red-500 font-semibold mb-4" data-id="element-378">
          04 — Who Said It?
        </motion.span>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="bg-slate-900/80 border border-slate-800 rounded-3xl p-6 mb-8 relative" data-id="element-379">
          <MessageSquareQuote className="absolute -top-4 -left-2 w-10 h-10 text-red-500/40 rotate-12" data-id="element-380" />
          <p className="text-xl text-white font-medium leading-relaxed relative z-10 italic" data-id="element-381">
            “The most exciting conversations aren’t always the ones you expect.”
          </p>
        </motion.div>

        <motion.h3 initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="text-sm text-slate-400 mb-4 uppercase tracking-widest" data-id="element-382">
          Guess the team:
        </motion.h3>

        <div className="grid grid-cols-2 gap-3 flex-1" data-id="element-383">
          {teams.map((team, i) => {
          const isSelected = selected === team;
          const isCorrect = team === 'Medical'; // Arbitrary correct answer
          let buttonClass = 'p-4 rounded-2xl border transition-all duration-300 flex items-center justify-center text-center h-24 ';
          if (!revealed) {
            buttonClass += isSelected ? 'bg-red-600/20 border-red-500 text-white scale-95' : 'bg-slate-900/80 border-slate-800 text-slate-300 hover:border-slate-600';
          } else {
            if (isCorrect) {
              buttonClass += 'bg-green-500/20 border-green-500 text-white';
            } else if (isSelected) {
              buttonClass += 'bg-slate-800/50 border-slate-700 text-slate-500 opacity-50';
            } else {
              buttonClass += 'bg-slate-900/30 border-slate-800 text-slate-600 opacity-50';
            }
          }
          return <motion.button key={team} initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.3 + i * 0.1
          }} onClick={() => handleSelect(team)} disabled={revealed} className={buttonClass} data-id="element-384">
                <span className="text-sm font-medium" data-id="element-385">{team}</span>
              </motion.button>;
        })}
        </div>

        <AnimatePresence data-id="element-386">
          {revealed && <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="mt-6" data-id="element-387">
              <button onClick={onNext} className="w-full bg-red-600 hover:bg-red-500 text-white font-semibold py-4 rounded-2xl flex items-center justify-center space-x-2 transition-all active:scale-[0.98]" data-id="element-388">
                <span data-id="element-389">Reveal Answer</span>
                <ArrowRight className="w-5 h-5" data-id="element-390" />
              </button>
            </motion.div>}
        </AnimatePresence>
      </div>
    </div>;
};